import compose from 'recompose/compose';
import lifecycle from 'recompose/lifecycle';
import withHandlers from 'recompose/withHandlers';
import Tile from './tile';
import {getDownloadURL} from '../../../../firebase/storage/download';
import cancelable from '../../../../../util/cancelable-promise';
import {FILE_TYPE_VIDEO} from '../../../common/types';
import {extractVideoId, previewPoster} from '../../../../../util/youtube';

const enhance = compose(
	lifecycle({
		componentWillMount() {
			const meta = this.props.item;

			/* async poster fetching prevent long waiting of tile rendering */
			if (meta.poster) {
				const {collection, poster} = meta;
				const fetchPoster = cancelable(getDownloadURL(`${collection}/${poster}`));

				fetchPoster.promise.then(image => this.setState({poster: image}));

				this.setState({fetchPoster});
			} else if (meta.type === FILE_TYPE_VIDEO && meta.streaming) {
				const videoId = extractVideoId(meta.streaming);

				if (videoId) {
					const poster = previewPoster(videoId);

					this.setState({poster});
				}
			}
		},
		componentWillUnmount() {
			if (this.state !== null && this.state.fetchPoster) {
				this.state.fetchPoster.cancel();
			}
		}
	}),
	withHandlers({
		handleOpenFile: props => () => {
			props.handleOpenFile(props.item.id, props.item.type);
		}
	})
);

export default enhance(Tile);



// WEBPACK FOOTER //
// ./src/client/components/main/files/tile/index.js